module.exports = __webpack_public_path__ + "img/charger.f18b3f51.png";